import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['check'], // 为了获取基础路由
    };
};
export const checkToPathNameMap = {
    // 检查
    check1010: ({ businessKey }) => {
        return commonFunc(`/check/detail?id=${businessKey}`);
    },
    // 整改
    check1020: ({ businessKey }) => {
        return commonFunc(`/rectify/detail?id=${businessKey}`);
    },
    // 复改
    check1030: ({ businessKey }) => {
        return commonFunc(`/recheck/detail?id=${businessKey}`);
    },
};
